import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";

const normalizeDatadogUser = (user) => {
  const organization =
    typeof user.organization === "string"
      ? user.organization
      : user.organization?.name;

  return {
    id: String(user.id),
    ...(user.email ? { email: user.email } : {}),
    ...(user.name ?? user.email ? { name: user.name ?? user.email } : {}),
    ...(organization ? { organization } : {}),
  };
};

export const setDatadogUser = (user) => {
  if (!user?.id) {
    return;
  }

  const datadogUser = normalizeDatadogUser(user);

  try {
    datadogRum.setUser(datadogUser);
    datadogLogs.setUser(datadogUser);
  } catch {
    // Datadog can be unavailable during bootstrap/logout transitions.
  }
};

export const clearDatadogUser = () => {
  try {
    datadogRum.clearUser();
    datadogLogs.clearUser();
  } catch {
    // Datadog can be unavailable during bootstrap/logout transitions.
  }
};
